import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { setMaxPage } from "../../../redux/actions.main";
import Pagination from "./Pagination";

const PaginationContainer = ({ currentPage }) => {
  const { maxPage } = useSelector((state) => state.main);
  const dispatch = useDispatch();

  const turnPageBack = () => {
    if (+currentPage > 1) {
      return +currentPage - 1;
    }
    return currentPage;
  };

  const turnPageForward = () => {
    if (+currentPage < maxPage) {
      return +currentPage + 1;
    }
    return currentPage;
  };

  const pathBase = "/main/";

  function getPaginationButtonsValues() {
    const currentMaxPage = localStorage.getItem("maxPage");
    if (currentMaxPage) {
      if (currentMaxPage !== maxPage) {
        dispatch(setMaxPage(currentMaxPage));
      }
      return {
        toStart: pathBase + "1",
        back: pathBase + turnPageBack(),
        forward: pathBase + turnPageForward(),
        toEnd: pathBase + maxPage,
      };
    }
    return {
      toStart: pathBase + "1",
      back: pathBase + "1",
      forward: pathBase + "2",
      toEnd: pathBase + "1",
    };
  }

  const pagination = getPaginationButtonsValues();

  return <Pagination currentPage={currentPage} pagination={pagination} />;
};

export default PaginationContainer;
